import React from 'react';
import { ExternalLink } from 'lucide-react';
import SecFilingDetailSections from './SecFilingDetailSections';
import { resolveSecFilingPageUrl } from '../utils/secEdgarUrls';

export default function SecFilingDetailDrawer({ filing, onClose }) {
  const isOpen = Boolean(filing);
  const edgarUrl = resolveSecFilingPageUrl(filing);

  const handleMoreInfo = () => {
    if (!edgarUrl) return;
    window.open(edgarUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={`drawer sec-filing-table-drawer${isOpen ? ' drawer-open' : ''}`}>
      {filing && (
        <>
          <div className="drawer-header">
            <div>
              <div className="drawer-tn">{filing.accessionNumber || '—'}</div>
              <div className="drawer-company">{filing.companyShort || filing.company}</div>
              <div className="drawer-toi">
                {filing.filingType}
                {filing.cik ? ` · CIK ${filing.cik}` : ''}
              </div>
            </div>
            <button type="button" className="drawer-close filters-drawer-close" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>

          <div className="drawer-tabs">
            <div className="dt active">Details</div>
          </div>

          <div className="drawer-body">
            <SecFilingDetailSections filing={filing} />
          </div>

          <div className="drawer-actions">
            <button
              type="button"
              className="btn btn-sm btn-filters sec-filing-table-drawer__more-info-btn"
              onClick={handleMoreInfo}
              disabled={!edgarUrl}
              title={edgarUrl ? 'Open this filing on sec.gov' : 'SEC filing page unavailable'}
            >
              <span>Visit SEC</span>
              <ExternalLink size={14} aria-hidden="true" />
            </button>
          </div>
        </>
      )}
    </div>
  );
}
